import { render, staticRenderFns } from "./ExpressOrder.vue?vue&type=template&id=1e0cdf63"
import script from "./ExpressOrder.vue?vue&type=script&lang=js"
export * from "./ExpressOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports